module.exports = require("./fr-TG.d.ts");